// extracted by mini-css-extract-plugin
module.exports = {"emptyMessage":"emptyMessage_emptyMessage__249VD","image":"emptyMessage_image__2Ojpp","message":"emptyMessage_message__3m4RJ"};